export const themeMap: Record<string, string> = {
    autoTheme: 'CLIENT_AUTO_SELECT_THEME',
    light: 'CLIENT_LIGHT_THEME',
    dark: 'CLIENT_DARK_THEME',
};
